export const relationshipMap = {
  SPOUSE: 'spouse',
  CHILD: 'child',
  PARENT: 'parent',
  GRANDPARENT: 'grandparent',
  AUNT_UNCLE: 'aunt-uncle',
  SIBLING: 'sibling',
  NOT_RELATED: 'not-related',
  OTHER: 'other'
};

export const relationshipLocaleMap = {
  [relationshipMap.SPOUSE]: 'spouse',
  [relationshipMap.CHILD]: 'child',
  [relationshipMap.PARENT]: 'parent',
  [relationshipMap.GRANDPARENT]: 'grandparent',
  [relationshipMap.AUNT_UNCLE]: 'auntUncle',
  [relationshipMap.SIBLING]: 'sibling',
  [relationshipMap.NOT_RELATED]: 'notRelated',
  [relationshipMap.OTHER]: 'other'
};

// Child relationship
export function isValidRelationship(relationship) {
  const validRelationshipList = [
    relationshipMap.PARENT,
    relationshipMap.GRANDPARENT,
    relationshipMap.SIBLING
  ];
  // isAdvisor && validRelationshipList.push(relationship.OTHER);
  return validRelationshipList.includes(relationship);
}

export function getChildRelationshipOptions(planType = 'family', localized) {
  const items = [
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.PARENT]] || 'Parent',
      value: relationshipMap.PARENT
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.GRANDPARENT]] ||
        'Grandparent',
      value: relationshipMap.GRANDPARENT
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.SIBLING]] ||
        'Sibling',
      value: relationshipMap.SIBLING
    },
    ...(planType === 'individual'
      ? [
          {
            label:
              localized?.[relationshipLocaleMap[relationshipMap.AUNT_UNCLE]] ||
              'Aunt or uncle',
            value: relationshipMap.AUNT_UNCLE
          },
          {
            label:
              localized?.[relationshipLocaleMap[relationshipMap.NOT_RELATED]] ||
              'Not Related',
            value: relationshipMap.NOT_RELATED
          },
          {
            label:
              localized?.[relationshipLocaleMap[relationshipMap.OTHER]] ||
              'Other',
            value: relationshipMap.OTHER
          }
        ]
      : [])
  ];
  return items;
}

// Cosub Relationship
export function getCoSubRelationshipOption(
  isAdvisor = false,
  localized,
  value
) {
  const options = getCoSubRelationshipOptions(isAdvisor, localized);
  return options && options.filter((option) => option.value === value)[0];
}

export function getCoSubRelationshipOptions(isAdvisor = false, localized) {
  const options = [
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.SPOUSE]] ||
        'Spouse or common-law partner',
      value: 'spouse'
    },

    !isAdvisor && {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.CHILD]] || 'Child',
      value: 'child'
    },
    !isAdvisor && {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.GRANDCHILD]] ||
        'Grandchild',
      value: 'grandchild'
    },
    !isAdvisor && {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.SIBLING]] ||
        'Sibling',
      value: 'sibling'
    },
    !isAdvisor && {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.NOT_RELATED]] ||
        'Not Related',
      value: 'not-related'
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.OTHER]] || 'Other',
      value: 'other'
    }
  ];
  return options.filter((option) => option);
}

export function getChildRelationshipFullOptions(localized) {
  const items = [
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.PARENT]] || 'Parent',
      value: relationshipMap.PARENT
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.GRANDPARENT]] ||
        'Grandparent',
      value: relationshipMap.GRANDPARENT
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.SIBLING]] ||
        'Sibling',
      value: relationshipMap.SIBLING
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.AUNT_UNCLE]] ||
        'Aunt or uncle',
      value: relationshipMap.AUNT_UNCLE
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.NOT_RELATED]] ||
        'Not Related',
      value: relationshipMap.NOT_RELATED
    },
    {
      label:
        localized?.[relationshipLocaleMap[relationshipMap.OTHER]] || 'Other',
      value: relationshipMap.OTHER
    }
  ];
  return items;
}
